import { useProductsFilter } from './use-products-filter.hook';

export const useProductsCount = (products, filters) => {
  return useProductsFilter(products, filters).length;
};
